import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconColorRoll: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="color-roll, paint-roller">
      <path
        d="M7 7V10H20V4H7V7ZM7 7H4V13H13V15.5M15 21V18C15 16.8954 14.1046 16 13 16C11.8954 16 11 16.8954 11 18V21"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
    </CentralIconBase>
  );
};

export default IconColorRoll;
